import { Button, Card, CardContent, CardMedia } from "../../../../../ui";
import styles from "./../../styles.module.scss";
import convenia from "./../../../../../assets/convenia-logo.png";
import { toast } from "react-toastify";
import { startResourceImport } from "../../../../../services/api/ResourceImport/ResourceImportService";
import { addOrUpdateConfigurations } from "../../../../../services/api/Configurations/ConfigurationService";
import { IConfiguration } from "../../../../../@types/configuration.type";

interface CardConveniaProps {
  isConveniaConfigured: boolean;
  configurations: IConfiguration[];
  setLoading: (loading: boolean) => void;
  handleOpen: () => void;
  showConfirm: () => Promise<unknown>;
  setIsConveniaConfigured: (item: boolean) => void;
}

export function CardConvenia({
  isConveniaConfigured,
  configurations,
  setLoading,
  handleOpen,
  showConfirm,
  setIsConveniaConfigured
}: CardConveniaProps) {
  
  const syncronizeResourcesWithConvenia = () => {
    setLoading(true);
    startResourceImport(1)
      .then(() => {
        setLoading(false);
        toast.success("Sincronização com convênia realizada com sucesso");
      })
      .catch(() => {
        toast.error("Falha na sincronização com o convênia");
      });
  };

  const disconnectConvenia = async () => {
    const isConfirm = await showConfirm();
    if (!isConfirm) return;

    try {
      setLoading(true);

      const configurationsToUpdate = configurations
        .filter(x => x.key === "CONFIGURATION_CONVENIA_TOKEN")
        .map(config => ({
          ...config,
          value: "",
        }));

      await addOrUpdateConfigurations(configurationsToUpdate);

      setIsConveniaConfigured(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardContent>
        <p>Sincronize seus colaboradores com o Convênia</p>
        <CardMedia
          sx={{
            backgroundSize: "contain",
            margin: "15px 0",
            height: "100px",
          }}
          image={convenia}
          title="convenia"
        />
        <div className={styles.btnContainer}>
          {!isConveniaConfigured ? (
            <div>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className={styles.btnConfigure}
                onClick={handleOpen}
              >
                Configurar
              </Button>
            </div>
          ) : (
            <div className={styles.btnsConnected}>
              <Button
                variant="outlined"
                color="primary"
                type="submit"
                className={styles.btnDisconnect}
                onClick={() => disconnectConvenia()}
              >
                Desconectar
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className={styles.btnSincronize}
                onClick={() => syncronizeResourcesWithConvenia()}
              >
                Sincronizar agora
              </Button>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
